import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { useProduct } from "@/lib/product";

export const COMPANY = {
  name: "Robert CLERC EI",
  trade: "EAUVÈO",
  site: "ClimNova",
  address: "47 rue Vivienne, 75002 Paris",
  siren: "378 932 396",
  rcs: "R.C.S. Paris 378 932 396",
  vat: "FR74 378 932 396",
};

export const useCompany = () => {
  const { product } = useProduct();
  return { ...COMPANY, email: product?.contact_email || "" };
};

export const Mediator = ({ email }) => (
  <>
    <p>Conformément aux articles L611-1 et suivants du Code de la consommation, après une réclamation écrite préalable restée sans réponse satisfaisante auprès de ClimNova (<a href={`mailto:${email}`}>{email}</a>), le consommateur peut saisir gratuitement le médiateur de la consommation dont relève le Vendeur, en vue de la résolution amiable du litige :</p>
    <ul data-testid="mediator-info">
      <li>ANM Conso (Association Nationale des Médiateurs)</li>
      <li>25 allée Rose Dieng Kuntz, 75019 Paris</li>
      <li>Site : <a href="https://www.anm-conso.com" target="_blank" rel="noopener noreferrer">https://www.anm-conso.com</a></li>
      <li>E-mail : <a href="mailto:contact@anmconso.com">contact@anmconso.com</a></li>
    </ul>
    <p>Le médiateur peut être saisi en ligne sur www.anm-conso.com ou par courrier à l'adresse ci-dessus.</p>
  </>
);

export const LegalLayout = ({ title, updated, testid, children }) => {
  useEffect(() => {
    document.title = `${title} | ClimNova`;
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div data-testid={testid}>
      <Header />
      <main className="bg-white">
        <div className="container-x max-w-3xl py-12 sm:py-20">
          <Link to="/" data-testid="legal-back-home" className="inline-flex items-center gap-2 text-sm text-sky-700 font-semibold hover:gap-3 transition-[gap]">
            <ArrowLeft className="w-4 h-4" /> Retour à l'offre
          </Link>
          <h1 data-testid="legal-title" className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 mt-8">{title}</h1>
          <p className="text-sm text-slate-500 mt-3">Dernière mise à jour : {updated}</p>
          <article className="legal mt-10">{children}</article>
        </div>
      </main>
      <Footer />
    </div>
  );
};
